import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Grid } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { NotificationMessage } from 'Components';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { VENDOR_FORM_NAME } from 'Common/FormEnum';
import { HeaderLeftAlign } from 'Common/Constants/table';

import { getVendorSetup } from './state/page/actions';
import {
  deleteVendor,
  clearVendorErrorSuccess,
} from './state/vendorDetails/actions';
import { DeleteDialog } from './components/DeleteDialog';

class VendorSetupContainer extends Component {
  static path = '/vendorsetup';

  static propTypes = {
    vendorSetup: PropTypes.object.isRequired,
    isGridLoading: PropTypes.bool.isRequired,
    deleted: PropTypes.bool.isRequired,
    deleting: PropTypes.bool.isRequired,
    deleteError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    getVendorSetup: PropTypes.func.isRequired,
    deleteVendor: PropTypes.func.isRequired,
    clearVendorErrorSuccess: PropTypes.func.isRequired,
  };

  static defaultProps = {
    deleteError: null,
  };

  state = {
    filtered: [],
    deleteDialog: {
      shown: false,
      vendor: null,
    },
  };

  componentDidMount() {
    this.props.getVendorSetup();
  }

  componentDidUpdate(prevProps) {
    const { clearVendorErrorSuccess } = this.props;
    if (errorToast(this.props, prevProps, 'deleteError')) {
      clearVendorErrorSuccess();
    } else if (this.props.deleted && !prevProps.deleted) {
      createToast(
        toastType.success,
        'Success',
        'Distributor has been deleted',
        true
      );
      this.props.getVendorSetup();
      clearVendorErrorSuccess();
    } else if (
      prevProps.vendorSetup.Errors !== this.props.vendorSetup.Errors &&
      this.props.vendorSetup.Errors &&
      this.props.vendorSetup.Errors.length > 0
    ) {
      NotificationMessage(this.props.vendorSetup);
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  onVendorAddClick = () => {
    this.props.history.push('/vendorsetup/0');
  };

  onVendorEditClick = row => {
    this.props.history.push(`/vendorsetup/${row.Id}`);
  };

  onEleFileClick = row => {
    this.props.history.push(`/vendorsetup/elefileconfig/${row.Id}`);
  };

  onDeleteClick = vendor => {
    this.setState({
      deleteDialog: {
        shown: true,
        vendor,
      },
    });
  };

  onDeleteConfirm = () => {
    this.props.deleteVendor(this.state.deleteDialog.vendor.Id);
    this.onDeleteCancel();
  };

  onDeleteCancel = () => {
    this.setState({
      deleteDialog: {
        shown: false,
        vendor: null,
      },
    });
  };

  columns = [
    {
      Header: () => <span className="ml-5">Distributor Id</span>,
      accessor: 'VendorNum',
      width: 250,
      filterable: true,
      resizable: true,
      ...HeaderLeftAlign,
    },
    {
      Header: () => <span className="ml-5">Distributor Name</span>,
      accessor: 'Description',
      filterable: true,
      resizable: true,
      ...HeaderLeftAlign,
    },
    {
      resizable: false,
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.menuOptions,
        });
      },
    },
  ];

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onVendorEditClick,
    },
    {
      icon: 'file',
      text: 'Configure Elec. File',
      handler: this.onEleFileClick,
    },
    {
      icon: 'trash',
      text: 'Delete Distributor',
      className: 'danger',
      handler: this.onDeleteClick,
      disabledWhen: vendorRow => this.props.isReadOnly || vendorRow.Status,
    },
  ];

  render() {
    return (
      <Fragment>
        <Filter title="Distributors">
          <Grid>
            <Grid.Row>
              <Grid.Column floated={'right'} textAlign={'right'}>
                <Button
                  content="Add Distributor"
                  onClick={this.onVendorAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <Button
            className={'clear-filters-button'}
            content="Clear Filters"
            onClick={() => this.setState({ filtered: [] })}
          />
          <DeleteDialog
            {...this.state.deleteDialog}
            onConfirm={this.onDeleteConfirm}
            onCancel={this.onDeleteCancel}
          />
          <ReactTable
            minRows={0}
            loading={this.props.isGridLoading}
            data={this.props.vendorSetup.Data}
            resizable={false}
            className={'-striped -highlight grid--fixed-row-height'}
            defaultFilterMethod={caseInsensitiveFilter}
            filtered={this.state.filtered}
            onFilteredChange={filtered => this.setState({ filtered })}
            columns={this.columns}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { vendorDetails, page } = state.VendorSetupState;
  ownProps.setPageLevelDirty(getIsDirty(VENDOR_FORM_NAME)(state));
  return {
    vendorSetup: page.vendorSetup,
    isGridLoading: page.isGridLoading,
    deleted: vendorDetails.deleted,
    deleting: vendorDetails.deleting,
    deleteError: vendorDetails.deleteError,
  };
};

const mapDispatchToProps = {
  getVendorSetup,
  deleteVendor,
  clearVendorErrorSuccess,
};

export const VendorSetup = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VendorSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/VendorSetup.js